
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

import { PricingProjectionRollup } from "./PricingProjectionRollup";
import { PricingProjectionDetail } from "./PricingProjectionDetail";

export class PricingProjectionRollups extends BaseBus {
    constructor(data: PricingProjectionRollups) {
        super();
        if (data) {

            this.billingCodes = data.billingCodes;
        }
        else {
            this.billingCodes = [];

        }
    }

    CID(): any {
        return 1;
    }
    setId(id: any) {
      //  this.billingCode = id;
    }
    initialize(data: PricingProjectionRollups) {
        super.initialize(data);

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setBeforeSave() {
    }
    setCommon(userId: any, date: Date, companyId: any = null) {

    }

    billingCodes: PricingProjectionRollup[];
    rawItems: PricingProjectionDetail[];

}
